export const ROOT_FONT_SIZE = 15;

export const SWIPER_GLOBAL_COMMON = {
    speed: 300,
    observer: true,
    observeParents: true,
    a11y: {
        prevSlideMessage: '이전 슬라이드 보기',
        nextSlideMessage: '다음 슬라이드 보기',
        lastSlideMessage: '마지막 슬라이드 입니다.',
        firstSlideMessage: '첫 번째 슬라이드 입니다.',
    }
};